import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePageComponent } from './home-page.component';
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {SidebarModule} from "primeng/sidebar";
import {LoginModule} from "../login/login.module";
import {InputTextModule} from "primeng/inputtext";
import {ShipmentTrackingModule} from "../shipment-tracking/shipment-tracking.module";
import {FormsModule} from "@angular/forms";



@NgModule({
  declarations: [HomePageComponent],
    imports: [
        CommonModule,
        ButtonModule,
        RippleModule,
        SidebarModule,
        LoginModule,
        InputTextModule,
        ShipmentTrackingModule,
        FormsModule
    ]
})
export class HomePageModule { }
